
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import AuthService from '../services/auth-service';

@Component
export default class UserRegisterComponent extends Vue {
  UserName: string = '';
  Password: string = '';
  ConfirmPassword: string = '';
  errors: string[] = [];
  EmailRules: any[] = [
    (v: any) => !!v || 'User name is required',
    (v: any) => /.+@.+\..+/.test(v) || 'User Name must be a valid E-mail'
  ];
  PasswordMatch: any[] = [
    (v: any) => !!v || 'Password match must have a value.',
    () => this.Password !== this.ConfirmPassword || 'Password does not match.',
    (v: any) => /\W/.test(v) || 'User Name must be a valid E-mail'
  ];
  private WaitDialog: boolean = false;
  private snackbarError: boolean = false;
  private errorText: string = 'Could not find username';
  get passwordConfirmationRule() {
    return () => this.Password === this.ConfirmPassword || 'Password must match';
  }
  goToLogin(): void {
    this.$router.push('/login');
  }
  changePassword(): void {
    this.WaitDialog = true;
    const formData: any = new FormData();
    formData.set('Username', this.UserName);
    formData.set('Password', this.Password);
    AuthService.changePassword(formData)
      .then(() => {
        // go to the thank you for registering page
        this.$router.push('about');
      })
      .catch(error => {
        // show a snack bar stating there was an error, and displaying the error
        this.WaitDialog = false;
        this.snackbarError = true;
        console.log(error);
      });
  }
}
